var _style, _rect, _rect2, _rect3, _ellipse, _ellipse2, _ellipse3, _rect4, _circle, _circle2, _circle3, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path3, _path4, _polygon, _path5, _path6, _circle4, _polygon2, _path7, _polygon3, _polygon4, _path8, _path9, _polygon5, _path10, _path11, _path12, _polygon6, _circle5, _polygon7, _polygon8, _polygon9, _path13, _polygon10, _path14, _polygon11, _rect17, _path15, _rect18, _path16, _polygon12, _polygon13, _rect19, _path17, _path18, _polygon14, _path19, _path20, _path21, _circle6, _polygon15, _path22, _polygon16, _circle7, _path23, _path24, _rect20, _rect21, _rect22, _rect23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 890,
    height: 489,
    viewBox: "0 0 890.30174 489.29978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.fill-primary {\n\t\t\tfill: #7a98c4;\n\t\t}\n\n\t\t.fill-secondary {\n\t\t\tfill: #b48e38;\n\t\t}\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 0.4,
    width: 703.6,
    height: 450.6,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 245.2,
    y: 60.9,
    width: 254,
    height: 261,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 594.2,
    y: 66,
    width: 254,
    height: 317,
    fill: "#ffffff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 844.8,
    cy: 477.3,
    rx: 45.5,
    ry: 6.5,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.9,
    cy: 477.4,
    rx: 45.5,
    ry: 6.5,
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.4,
    cy: 470.9,
    rx: 104.4,
    ry: 5,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    width: 703.6,
    height: 29.9,
    className: "fill-primary"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204.9,
    cy: 15.3,
    r: 5.5,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.9,
    cy: 15.3,
    r: 5.5,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.9,
    cy: 15.3,
    r: 5.5,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 947 356.3 H 945.5 V 314.2 a 24.4 24.4 0 0 0 -24.4 -24.4 H 831.8 a 24.4 24.4 0 0 0 -24.4 24.4 V 545.4 a 24.4 24.4 0 0 0 24.4 24.4 h 89.3 a 24.4 24.4 0 0 0 24.4 -24.4 V 386.4 h 1.5 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 921.1 296.1 H 909.4 a 8.7 8.7 0 0 1 -8 11.9 H 850.3 A 8.7 8.7 0 0 1 842.2 296.1 H 831.4 a 18.2 18.2 0 0 0 -18.2 18.2 v 230.9 a 18.2 18.2 0 0 0 18.2 18.2 h 89.7 a 18.2 18.2 0 0 0 18.2 -18.2 v -230.9 A 18.2 18.2 0 0 0 921.1 296.1 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 225.8,
    width: 176.5,
    height: 8.1,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 251.8,
    width: 176.5,
    height: 8.1,
    className: "fill-primary"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 277.8,
    width: 176.5,
    height: 8.1,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 670.8,
    y: 243.3,
    width: 103.1,
    height: 8.1,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 670.8,
    y: 268.3,
    width: 103.1,
    height: 8.1,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 670.8,
    y: 293.3,
    width: 103.1,
    height: 8.1,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 922.4,
    y: 606.6,
    width: 17.2,
    height: 17.2,
    transform: "translate(1391.2,-521.1) rotate(90)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 894.7,
    y: 606.6,
    width: 17.2,
    height: 17.2,
    transform: "translate(1363.6,-493.5) rotate(90)",
    className: "fill-primary"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 867,
    y: 606.6,
    width: 17.2,
    height: 17.2,
    transform: "translate(1335.9,-465.8) rotate(90)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 839.3,
    y: 606.6,
    width: 17.2,
    height: 17.2,
    transform: "translate(1308.2,-438.1) rotate(90)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 811.7,
    y: 606.6,
    width: 17.2,
    height: 17.2,
    transform: "matrix(0,1,-1,0,1280.5,-410.4)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 692.7,
    y: 139,
    width: 57.3,
    height: 57.3,
    className: "fill-primary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 504.5 480.9 l -0.7 1.5 l -2.2 -11.1 s -3 -11.9 3 -11.9 s 4.4 11.9 4.4 11.9 v 8.2 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 601.7 479.4 l 0.7 1.5 l 2.2 -11.1 s 3 -11.9 -3 -11.9 s -4.4 11.9 -4.4 11.9 V 477.9 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "382.2,359.9 373.3,414.8 377.8,468.1 388.1,463.7 386.7,423.7 397,391.8 399.3,429.6 394.8,468.9 408.2,470.4 417.8,389.6 417,362.2 382.2,359.9",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 537.1 665.8 l -5.2 8.2 V 692.2 a 2.2 2.2 0 0 0 1.9 2.2 c 2.5 0.4 7 0.7 8.5 -1.9 c 2.2 -3.7 0.7 -11.9 0.7 -11.9 s 3 -5.9 1.5 -10.4 s -3 -5.2 -3 -5.2 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 559.3 673.2 l 1.5 2.2 s 2.2 2.2 0.7 3.7 a 29 29 0 0 0 -3 3.7 s -8.2 2.2 -8.2 -0.7 v -9.6 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.8,
    cy: 288.8,
    r: 9.8,
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.2,291.9 394.4,305.9 407.8,306.7 407,292.6 395.2,291.9",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 564.5 512.4 l -2.1 -5.1 s -9.8 -3.8 -12.7 0 l -1.5 4.4 l -11.9 -3 l -6.7 14.8 l 5.9 42.2 s 15.6 20 36.3 0.7 l 5.9 -40 L 573.4 510.9 Z",
    transform: "translate(-154.8,-205.4)",
    className: "fill-secondary"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "417,308.5 418.5,305.6 433.4,296.7 442.4,269.9 449.4,272.9 441.5,304.8 420,324.8 417,308.5",
    className: "fill-secondary"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "383,304.8 381.5,303.4 365.9,293.7 354.8,271.5 345.9,274.4 355.5,301.9 379.3,321.1 383,304.8",
    className: "fill-secondary"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 563.9 479.1 l 1.6 -0.8 l -2.4 -0.8 V 476.7 s -12 -4.8 -13.7 3.2 a 16.1 16.1 0 0 0 0 19.3 v 2.4 l 12.9 1.6 l 1.6 -4.8 S 572 483.9 563.9 479.1 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 269.9 565.2 l -2.9 1.4 s -11.4 5.2 -8.1 8.1 s 12.4 -2.9 12.4 -2.9 l 1.9 -2.4 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffb8b8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.6,359.1 189.8,418.3 176.5,459.7 169.3,456.4 176,399.8 157,383.6 158.4,359.8 198.6,359.1",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 323.2 663.2 s 8.1 -4.3 8.6 1.9 l -1 6.2 s 2.9 10.9 -6.7 8.6 s -2.9 -9.5 -2.9 -9.5 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 318 583.7 l -6.2 5.2 s 0 32.4 4.3 37.1 s 31.4 29 32.4 30 s 5.2 -9.5 5.2 -9.5 l -25.7 -30 l 1.9 -18.6 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 350.8 645.1 s 7.6 -1.4 7.6 3.8 a 115.2 115.2 0 0 0 1 12.4 s 1.9 16.7 -4.3 14.3 s -8.6 -19 -8.6 -19 a 7.1 7.1 0 0 1 2.9 -3.3 C 351.3 652.3 350.8 645.1 350.8 645.1 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.2,288.4 173.6,306 169.8,312.7 159.3,302.7 158.4,289.4 172.2,288.4",
    fill: "#ffb8b8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.6,
    cy: 282.7,
    r: 11.4,
    fill: "#ffb8b8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.4,305.6 173.2,291.8 181.7,301.3 197.4,361.7 185.5,368.9 180.3,361.2 179.3,371.2 156,366.5 154.1,302.7 158.9,296 168.4,305.6",
    fill: "#d0cde1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.7,373.1 158.9,296 152.7,300.8 141.3,308.4 148.9,335.5 151.3,364.1 161.7,373.1",
    className: "fill-secondary"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.6,308.9 141.3,308.4 131.7,336.5 112.7,360.3 119.8,367.9 141.7,346.5 149.8,328.9 144.6,308.9",
    className: "fill-secondary"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 351.4 565.6 l -0.6 3.1 s -3 12.2 1.3 11.4 s 5.4 -11.5 5.4 -11.5 l -0.7 -3 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffb8b8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.4,291 196,300.3 193.1,328.9 198.8,360.3 193.1,366.5 172,295 172.4,291",
    className: "fill-secondary"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 319.1 468.9 l 3.4 -1.7 v 1.7 l 2.2 -1.1 v 2.8 s 8.4 6.1 6.7 13.4 s -1.7 7.8 -1.7 7.8 s -2.1 -13.8 -10.5 -11.6 s -9.1 2.6 -11.3 8.8 l -0.6 2.6 S 297.8 470 319.1 468.9 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.7,300.3 196.5,300.3 202.7,333.6 202.7,362.7 195,361.2 188.9,317.5 192.7,300.3",
    className: "fill-secondary"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 370.8,
    width: 140.3,
    height: 97.5,
    className: "fill-primary"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 228.5 595.1 a 29.7 29.7 0 1 0 29.7 29.7 A 29.8 29.8 0 0 0 228.5 595.1 Z m 0 8.9 a 8.9 8.9 0 1 1 -8.9 8.9 a 8.9 8.9 0 0 1 8.9 -8.9 Z m 0 42.9 a 21.7 21.7 0 0 1 -17.8 -9.5 c 0.1 -5.9 11.9 -9.2 17.8 -9.2 s 17.7 3.3 17.8 9.2 a 21.7 21.7 0 0 1 -17.8 9.5 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffffff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 284.2,
    y: 90.9,
    width: 176,
    height: 101,
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 963.1 496.6 l 0.8 -5.3 s 4.8 -10.8 1 -11.4 s -6.9 9.7 -6.9 9.7 l 1.4 11 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffb8b8"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "846.7,321.1 813.1,314.3 809.2,289.8 799.3,289.1 799.8,320.7 829,336 846.7,321.1",
    className: "fill-secondary"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "846.7,321.1 813.1,314.3 809.2,289.8 799.3,289.1 799.8,320.7 829,336 846.7,321.1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 910.2,
    y: 482.1,
    width: 103.1,
    height: 8.1,
    transform: "translate(1768.5,766.8) rotate(-180)",
    className: "fill-primary"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 956.5 494.8 l 0 -5.3 s 3.1 -11.4 -0.7 -11.4 s -5.3 10.6 -5.3 10.6 l 3 10.6 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 1000.2 510 l 4.6 -1.1 a 11.9 11.9 0 0 0 11.6 -14.2 h 0 a 15.5 15.5 0 0 0 -15.5 -15.5 h 0 A 15.5 15.5 0 0 0 985.4 494.7 v 0 A 12.3 12.3 0 0 0 1000.2 510 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "818.3,381.5 822,422.5 828.8,462.8 840.2,462.8 838.7,423.3 832.7,375.4 818.3,381.5",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 985.2 665.9 l -7.6 4.6 s -12.2 1.5 -9.9 5.3 s 28.9 1.6 28.9 0 s -0.7 -9.9 -2.3 -9.9 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 1006.8 583.3 s -0.2 5.9 -5.5 15 l 0.7 28.1 l 27.3 35 l -9.9 8.4 l -33.4 -38.1 l -8.3 -45.6 l 10.7 -10.6 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 1027 661.4 s 9.1 1.5 7.6 5.3 s -5.3 21.3 -15.2 19 c 0 0 -4.6 0 -3 -3 a 55 55 0 0 1 3 -5.3 l 0 -9.9 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.4,
    cy: 294,
    r: 11.4,
    fill: "#ffb8b8"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "845.7,301.7 845.7,314.6 833.5,314.6 835.1,301.6 845.7,301.7",
    fill: "#ffb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 985.4 515.3 l 3.7 -0.9 l 11.5 0.9 s 6.1 6.1 5.3 7.6 s -4.6 38.8 -4.6 38.8 l 6.8 26.6 l -24.3 1.5 l -12.2 -1.5 l 2.3 -47.9 s -5.3 -12.9 1.5 -16.7 A 30 30 0 0 0 985.4 515.3 Z",
    transform: "translate(-154.8,-205.4)",
    className: "fill-secondary"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "844.2,313.1 810,311.5 802.4,287.9 792.5,288.7 797.8,319.8 829,330.5 844.2,313.1",
    className: "fill-secondary"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.4,
    cy: 278.3,
    r: 7.4,
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 1010.5 479.7 a 7.4 7.4 0 0 1 8.8 -7.2 A 7.4 7.4 0 1 0 1014.7 486.3 A 7.4 7.4 0 0 1 1010.5 479.7 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 1004.2 483.8 l -9.9 -1.8 l -7.6 4.8 a 11.6 11.6 0 0 0 -5.3 11.3 l 7.6 -1.9 l 1.7 -4.3 l 2 3.3 l 8.3 14.5 l 8.4 -4.6 l 5.3 -8.4 Z",
    transform: "translate(-154.8,-205.4)",
    fill: "#2f2e41"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 245.3,
    width: 2,
    height: 202.9,
    transform: "translate(-190.9,425.9) rotate(-60.2)",
    fill: "#ffffff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 425.6,
    y: 345.8,
    width: 202.9,
    height: 2,
    transform: "translate(-257.5,102.9) rotate(-29.8)",
    fill: "#ffffff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 875.5,
    y: 332.5,
    width: 2,
    height: 80.6,
    transform: "translate(-161.7,523.6) rotate(-45)",
    fill: "#ffffff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 836.2,
    y: 371.8,
    width: 80.6,
    height: 2,
    transform: "translate(-161.7,523.6) rotate(-45)",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIllustration);
export default __webpack_public_path__ + "static/media/welcome_illustration.4c3a682c409d1e651cb6cff174271b49.svg";
export { ForwardRef as ReactComponent };